/**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el = $(el);
const $slider = $el.find('.wrap-actions');

const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    dots: false,
    arrows: true,
    centerMode: true,
    variableWidth: true,
    prevArrow: '<button type="button" class="slick-prev"><svg class="icon-arrow"><use xlink:href="#svg-arrow-prev" /></svg><span class="text-arrow">Anterior</span></button>',
    nextArrow: '<button type="button" class="slick-next"><svg class="icon-arrow"><use xlink:href="#svg-arrow-next" /></svg><span class="text-arrow">Próxima</span></button>',
    mobileFirst: true,
    centerPadding: '40px',
    responsive: [
        {
            breakpoint: 1023,
            settings: "unslick"
        },
    ]
};

const sl = $slider.slick(settings);
// $slider.slick('slickSetOption', 'slidesToScroll', 1, true);

$window.on('resize', function() {
    if( $(window).width() < 992 && !sl.hasClass('slick-initialized')) {
        $slider.slick(settings);
        // $slider.slick('slickSetOption', 'slidesToScroll', 1, true);
   }
});
